import { RefObject, useEffect } from 'react'
import { getQueryRoot } from '../../../utils/getQueryRoot'

type Props = {
  loadingData?: boolean
  rootRef?: RefObject<HTMLElement | null>
}

export const useCalendarLoadingSpinner = ({ loadingData, rootRef }: Props) =>
  useEffect(() => {
    if (typeof document === 'undefined') return

    const root = getQueryRoot(rootRef?.current)
    const loadingSpinner: HTMLElement | null = root.querySelector(
      '.will-filter-bar-calendar .rdp-months .will-calendar-spinner'
    )
    if (loadingData) {
      if (loadingSpinner) loadingSpinner.style.display = 'flex'
    } else {
      if (loadingSpinner) loadingSpinner.style.display = 'none'
    }
  })
